






















































































































































































import { Component, Watch, Prop, Vue, Inject, InjectReactive } from 'vue-property-decorator';
import nationSelect from '@/components/common/nationSelect.vue';
import deptSelect from '@/components/common/deptSelect.vue';
import birthDate from '@/components/common/birthdate.vue';
import manageRank from '@/components/common/manageRank.vue';
import PoliticalOutlook from '@/components/common/politicalOutlook.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import axios from 'axios';
import UserModule from '@/store/modules/user';
import { Notify, Dialog, Toast } from 'vant';
import * as api from '@/api';
import * as models from '@/api/models';
import { datetime } from '@/utils/filter';
import unManageRank from '@/components/common/unManageRank.vue';
import { getUrlParam } from '@/utils/util';

@Component({
  components: { nationSelect, deptSelect, confirmFeedback, birthDate, manageRank, unManageRank, PoliticalOutlook },
})
export default class extends Vue {
  @Prop() phone: any;
  @Prop() verCode: string;
  @Watch('verCode', { deep: true, immediate: true })
  valueChange(v: string) {
    this.form.VerCode = v;
  }

  isLoading: boolean = false;
  showUnManageRankPicker: boolean = false; // 非管理职级组件显隐
  showDatePicker: boolean = false;
  feedbackShow: boolean = false;
  feedbackType: string = '';
  successStatu: boolean = false;
  errorMsg: string = '';
  finished: boolean = false;
  previewImg: any = '';
  showNationPicker: boolean = false;
  showDeptPicker: boolean = false;
  showManageRankPicker: boolean = false;
  showPoliticalOutlookPicker: boolean = false;
  stuImgs: any = [];
  ajaxUrl: any = apiAxios.getUri;
  ranks: any = [];
  deptName: string = ''; // 单位名称
  showCitySelectorPicker: boolean = false;
  pcList: string[] = [
    '南宁市',
    '柳州市',
    '桂林市',
    '梧州市',
    '北海市',
    '防城港市',
    '钦州市',
    '贵港市',
    '玉林市',
    '百色市',
    '贺州市',
    '河池市',
    '来宾市',
    '崇左市',
  ];

  form: Partial<any> = {
    Username: '',
    Phone: '',
    Name: '',
    Sex: '',
    Nation: '',
    Political: '',
    OrgId: null,
    WorkUnit: '',
    Job: '',
    Birthday: '',
    PostRank: null,
    UnManageRank: null,
    OpenId: '',
    Signature: '',
    VerCode: '',
    City: '',
  };

  postRankValue: string = '';
  unManageRankValue: string = '';

  @InjectReactive({ from: 'wxOpenId' }) wxOpenId;
  @InjectReactive({ from: 'Signature' }) Signature;

  jobRules: any = [
    {
      required: true,
      message: '请输入职务',
    },
    {
      validator: this.validateContent,
      message: '职务不能为“暂无”或者“无”',
    },
  ];

  validateContent(value, callback) {
    if (value === '暂无' || value === '无') {
      return false;
    } else {
      return true;
    }
  }

  onPcitysConfirm(pcity) {
    this.form.City = pcity;
    // if (pcity[0].name != pcity[1].name) {
    //   this.form.City = pcity[0].name + pcity[1].name;
    // } else {
    //   this.form.City = pcity[0].name;
    // }
    this.showCitySelectorPicker = false;
  }
  onPcitysCancel() {
    this.showCitySelectorPicker = false;
  }

  close() {
    this.$emit('close');
  }

  mounted() {
    this.form.Phone = this.phone;
  }

  /**填写说明 */
  fillingInstructions() {
    Dialog.alert({
      title: '填写说明',
      message: `<div style="text-align: left; display: flex; flex-direction: column;gap: 10px">
      <div>1、如果本人工作单位在区直单位、企业、高校、中直单位、区市(14个地市)、请直接选择对应的工作单位。</div>
      <div>2、如果本人工作单位属于下级单位请选择对应的上级区直单位、企业、中直单位、区市(14个地市)所属单位。</div>
      <div style="color: #4fc08d;">例如：</div>
      <div style="color: #4fc08d;">二级工作单位在桂林市疾控中心-> 请选择广西壮族自治区卫生健康委员会</div>
      <div style="color: #4fc08d;">二级工作单位在自治区公路发展中心->请选择广西壮族自治区交通运输厅</div>
      </div>`,
    });
  }

  // async getStudentInfo() {
  //   this.form.Username = `${this.form.Name + this.form.Birthday.replace(/-/g, '')}`;
  //   try {
  //     const { data } = await api.AccountApp.getStudentInfo_GET({
  //       name: this.form.Name,
  //       phone: this.form.Phone,
  //     });
  //     if (data) {
  //       this.form.WorkUnit = data.workUnit;
  //       this.form.Job = data.job;
  //     }
  //   } catch (error) {
  //     console.log('error', error);
  //   }
  // }

  dateConfirm(val: any) {
    this.showDatePicker = false;
    this.form.Birthday = datetime(val, 'YYYY-MM-DD');
    this.form.Username = `${this.form.Name + this.form.Birthday.replace(/-/g, '')}`;
  }

  dateCancel() {
    this.showDatePicker = false;
  }

  manRankConfirm(val) {
    this.form.PostRank = val.order;
    this.postRankValue = val.name;
    this.showManageRankPicker = false;
  }
  unManRankConfirm(val) {
    this.form.UnManageRank = val.order;
    this.unManageRankValue = val.name;
    this.showUnManageRankPicker = false;
  }

  /**政治面貌 */
  politicalOutlookConfirm(val) {
    this.form.Political = val.name;
    this.showPoliticalOutlookPicker = false;
  }

  async perInfoSubmit(e) {
    if (this.form.UnManageRank == null && this.form.PostRank == null) {
      Dialog.alert({
        title: '提示',
        message: '职务层次与职级至少要填写一个！',
      });
      return;
    }
    this.isLoading = true;
    try {
      this.feedbackShow = true;
      if (!this.wxOpenId) throw new Error('获取微信openId错误');
      this.form.OpenId = this.wxOpenId;
      this.form.Signature = this.Signature;
      const result: any = await api.AccountApp.localRegister_POST(this.form);
      if (result.success && result.data.success) {
        this.successStatu = true;
        this.$emit('registerSuccess', result.data);
      } else {
        throw new Error(result.message || result.data.message || '注册失败');
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 3500);
    } catch (err) {
      this.successStatu = false;
      this.errorMsg = err.message;
    } finally {
      this.finished = true;
    }
    this.feedbackType = '学员信息';
  }

  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
    this.isLoading = false;
  }
  nationConfirm(val: string) {
    this.showNationPicker = false;
    this.form.Nation = val;
  }
  nationCancel() {
    this.showNationPicker = false;
  }
  deptConfirm(dept: any) {
    this.showDeptPicker = false;
    this.deptName = dept.deptName;
    this.form.OrgId = dept.deptId;
    if (!this.form.WorkUnit) this.form.WorkUnit = this.deptName;
  }
  deptCancel() {
    this.showDeptPicker = false;
  }
}
export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
